import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';

const IntValEditor = forwardRef((props, ref) => {

    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);
    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? parseInt(selectedVal) : "0";
            },
            isPopup() {
                return false;
            }
        };
    });

    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
                container.select();
            }
        });
    };

    const onInputChange = val => {
        if (Number.isInteger(parseInt(val.target.value))) {
            props.node.setDataValue(props.column.colDef.field, val.target.value);
            setSelectedVal(parseInt(val.target.value).toString());
        }
    }

    return (
        <input style={{width:'100%'}} type="text" onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
        }} pattern="[0-9]*" className="ag-cell-inline-editing"
            value={selectedVal} ref={refContainer} 
            onChange={onInputChange}>
        </input>
    );
});
export default IntValEditor;